import React from "react";
import { useSelector } from "react-redux";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import NewWiFiSettings from "./NewWiFiSettings.jsx";
import WifiScheduleSettings from "./WiFiScheduleSettings.jsx";

//import DataUsageCard from "./WiFi.jsx";

function WiFi(props) {
  const userid = useSelector((state) => state.services.ids.user);
  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={10} lg={4}>
        <NewWiFiSettings pathids={{ wifisettings: userid }} />
      </GridItem>
      <GridItem xs={12} md={10} lg={8}>
      {false && <WifiScheduleSettings pathids={{ wifisettings: userid }} />}
      </GridItem>
    </GridContainer>
  );
}

export default WiFi;
